import * as Tone from 'tone';
import { Howl } from 'howler';
import { applyKey } from '@/util/piano-util';
import { store } from '@/model/store';
import { EVENT_BUS } from '@/model/event-bus';
import { calculateStepAndOctave } from '@/util/util';

Tone.context.lookAhead = 0;

const VOLUME_MUTE_DB = -80;
const METRONOME_VOULME_AUDIBLE_DB = store.settings.metronomeVolume;
const PIANO_VOULME_AUDIBLE_DB = store.settings.pianoVolume;
const MASTER = store.settings.musicVolume;
const updateProgress = (line) => console.debug(line);

export class Keysound {
    constructor() {
        this.initListeners();
    }


    async loadSampler(baseUrl, urls, attack = 0) {
        return new Promise((res) => {
            const sampler = new Tone.Sampler({
                urls,
                attack,
                baseUrl,
                onload: () => {
                    res(sampler);
                }
            }).toDestination();
        })
    }

    async load() {
        const pianoPromise = this.loadSampler(
            "public/samples/Upright-Piano-KW/", {
            A3: "A3vH.wav",
            A4: "A4vH.wav",
            A5: "A5vH.wav",
            A6: "A6vH.wav",
            B1: "B1vH.wav",
        }, 0.3).then(sampler => this.pianoSampler = sampler).catch(
            e => alert(e)
        );

        return pianoPromise.then(() => {
            this.pianoSampler.volume.value = PIANO_VOULME_AUDIBLE_DB;
        })

    }

    initListeners() {
        EVENT_BUS.on('MIDI_noteOn', ({ pianoNote }) => {
            const note = calculateStepAndOctave(pianoNote);
            this.pianoSampler.triggerAttack(
                note,
                // note.velocity
            );
        });
        EVENT_BUS.on('MIDI_noteOff', ({ pianoNote }) => {
            const note = calculateStepAndOctave(pianoNote);
            this.pianoSampler.triggerRelease(
                note,
                // note.velocity
            );
        });
    }
}

export class TonejsAudio {
    canPlay = false;
    ended = false;
    bpm
    beats
    clickTrack = true;
    playing = false;

    constructor(notes, {
        key, bpm, beats, clickTrack = true
    }) {
        this.key = key;
        this.bpm = bpm;
        this.clickTrack = clickTrack;
        this.beats = beats;
        this.duration = 0;
        notes.forEach((note) => {
            if (this.duration < note.timeSeconds + note.durationSeconds) {
                this.duration = note.timeSeconds + note.durationSeconds;
            }
        });
        this.notes = notes.filter(note => !!note.pitch);
        Tone.Transport.seconds = 0;
    }

    get beatIntervalSeconds() {
        return 1 * (60 / this.bpm);
    }

    async loadSampler(baseUrl, urls) {
        return new Promise((res) => {
            const sampler = new Tone.Sampler({
                urls,
                baseUrl,
                onload: () => {
                    res(sampler);
                }
            }).sync().toDestination();
        })
    }

    async load() {
        const pianoPromise = this.loadSampler(
            "public/samples/Upright-Piano-KW/", {
            A3: "A3vH.wav",
            A4: "A4vH.wav",
            A5: "A5vH.wav",
            A6: "A6vH.wav",
            B1: "B1vH.wav",
        }).then(sampler => this.pianoSampler = sampler);

        const metronomePromise = this.loadSampler(
            "public/sounds/fx/", {
            A3: "metronome.mp3"
        }).then(sampler => this.metronomeSampler = sampler);


        return Promise.all([pianoPromise, metronomePromise]).then(() => {
            this.canPlay = true;
            this.pianoSampler.volume.value = PIANO_VOULME_AUDIBLE_DB;
            this.metronomeSampler.volume.value = METRONOME_VOULME_AUDIBLE_DB;
        })

    }

    stop() {
        this.playing = false;
        // this.pianoSampler.volume.value = VOLUME_MUTE_DB;
        // this.metronomeSampler.volume.value = VOLUME_MUTE_DB;
        Tone.Transport.pause();
    }

    resume() {
        this.playing = true;
        // this.pianoSampler.volume.value = VOULME_AUDIBLE_DB;
        console.log(Tone.Transport.position + ' start' )
        Tone.Transport.toggle();
    }

    play() {
        if (!this.canPlay) {
            return;
        }

        //schedule all of the events
        this.notes.forEach((note) => {
            let { pitch } = note;
            pitch = applyKey(pitch, this.key);
            // this.pianoSampler.triggerAttackRelease(
            //     `${pitch.step}${pitch.octave}`,
            //     note.durationSeconds,
            //     note.timeSeconds 
            //     // note.velocity
            // );
            if (this.duration < note.timeSeconds + note.durationSeconds) {
                this.duration = note.timeSeconds + note.durationSeconds;
            }
        });

        // metronome
        if (this.clickTrack) {
            const ticks = this.duration / this.beatIntervalSeconds;
            let t = 0;
            while (t < ticks) {
                this.metronomeSampler.triggerAttackRelease(
                    `A3`,
                    0.3,
                    t * this.beatIntervalSeconds
                );
                t++;
            }
            console.log('t=' + t + ' ticks ');
        }
        this.resume();
        this.playing = true;
    }

    get currentTime() {
        return Tone.Transport.seconds;
    }

    get currentTimeOffsetted() {
        return Number(this.currentTime + store.settings.offset);
    }
}

export class Audio {
    canPlay = false;
    ended = false;
    id = 'audio'

    constructor(elementId) {
        this.id = elementId;
        this.volume = MASTER;
    }

    get duration() {
        return this.element?.duration;
    }

    get element() {
        if (!this._element) {
            this._element = document.createElement('audio');
            this._element.preload = "metadata";
            this._element.id = this.id;
            this._element.playbackRate = 1;
        }
        return this._element;
    }

    load(url) {
        url = url || this.id;
        updateProgress(`loading ${url} ... `);
        return new Promise((res, rej) => {
            this.element.addEventListener('progress', updateProgress);
            this.element.addEventListener('canplaythrough', () => {
                this.canPlay = true;
                updateProgress(`${url} is buffered! `);
                res();
            });
            this.element.addEventListener('error', () => {
                this.canPlay = false;
                updateProgress(`${url} canceled`);
                res();
            })
            this.element.src = url;
        })
    }

    async play() {
        this.element.addEventListener('ended', () => {
            this.ended = true;
        })

        return new Promise((res, rej) => {
            this.element.addEventListener('playing', () => {
                res();
            })
            this.element.play();
        })
    }

    stop() {
        this.element.pause();
    }

    resume() {
        this.element.play();
    }

    get currentTime() {
        return this.element.currentTime;
    }

    get currentTimeOffsetted() {
        return Number(this.currentTime + store.settings.offset);
    }

    setPosition(seconds) {
        this.element.currentTime = seconds;
    }

    /* 40 ... 100 */
    setSpeed(speed) {
        this.element.playbackRate = speed / 100;
        console.debug(`audio#setSpeed ${this.element.playbackRate}`)
    }

    set volume(val) {
        this.element.volume = val;
    }
}

export class MultitrackAudio {
    tracks = []
    urls = [];
    constructor(urls) {
        // if (config.debug.forceDisableMultitrackAudio) {
        //     urls = [urls[0]];
        // }
        this.urls = urls;
        urls.forEach(url => {
            this.tracks.push(new Audio(url));
        });
    }

    get duration() {
        return this.tracks[0].element?.duration;
    }

    async load() {
        await Promise.all(
            this.tracks.map((track) => track.load(track.id))
        ).then(() => {
            updateProgress('All audio files are loaded');
        });
        this.tracks = this.tracks.filter(t => t.canPlay);
    }

    async play() {
        return Promise.all([
            this.tracks.map(t => t.play())
        ]);
    }

    async stop() {
        this.tracks.forEach(t => t.stop());
    }

    resume() {
        this.tracks.forEach(t => t.resume());
    }

    get currentTime() {
        return this.tracks[0].element.currentTime;
    }

    get currentTimeOffsetted() {
        return Number(this.currentTime + store.settings.offset);
    }

    setPosition(seconds) {
        this.tracks.forEach(t => t.setPosition(seconds));
    }

    setSpeed(speed) {
        console.debug(`multitrackAudio#setSpeed ${this.element.playbackRate}`)
        this.tracks.forEach(t => t.setSpeed(speed));
    }

    set volume(val) {
        this.tracks.forEach(t => t.volume = val);
    }

    get ended() {
        const reducer = (e1, e2) => {
            if (typeof e1 === 'object') {
                return e1.ended && e2.ended;
            } else {
                return e1 && e2.ended;
            }
        };
        const ended = this.tracks.reduce(reducer);
        return ended;
    }

}

class Howls {
    constructor() {
        this.click1Howl = new Howl({
            volume: 0.1,
            src: ["public/sounds/tick_002.ogg"]
        });

        this.click2Howl = new Howl({
            volume: 0.1,
            src: ["public/sounds/select_008.ogg"]
        });

        this.youWin = new Howl({
            volume: 0.4,
            src: ["public/sounds/fx/fanfare.mp3"]
        });

        this.youLose = new Howl({
            volume: 0.4,
            src: ["public/sounds/fx/boo.mp3"]
        });

        // this.menuMusic = new Howl({
        //     src: ["public/sounds/bg-music.mp3"],
        //     autoplay: false,
        //     loop: true,
        //     volume: config.audio.mixer.menuMusic
        // });
    }

    click() {
        this.click1Howl.play();
    }

    click2() {
        this.click2Howl.play();
    }

    playMenuMusic() {
        this.menuMusic.play();
    }

    stopMenuMusic() {
        this.menuMusic.stop();
    }

}

export const Fx = new Howls();